import { useState, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Col } from 'antd';

import { AuthContext } from '../../contexts/AuthContext';
import { PageView, PageViewSection } from '../../components/PageView';

import PlanCard from './PlanCard';

import './index.css';


export default function Plan() {
    const actx = useContext(AuthContext);
    const { t } = useTranslation('appxweb');
    const [ loading, setLoading ] = useState(false);
    const [ plans, setPlans ] = useState([]);

    useEffect(() => {
        async function fetchData() {
            const response = await actx.doModelAction({
                model: 'plan',
                action: 'getpublicplans'
            });

            if (response != null && Array.isArray(response.data)) {
                setPlans(response.data);
            }

            setLoading(false);
        }

        fetchData();
    }, [actx]);

    return (
        <PageView
            leadText={t('Plan.leadText')}
            title={t('Plan.title')}
            loading={loading}>
            <PageViewSection
                className="plan-section"
                title={t('Plan.section_title')}>
                {plans.length > 0 ? (
                <Row
                    gutter={16}
                    wrap={true}>
                    {plans.map((plan, idx) => (
                    <Col key={`pland-card-${plan.id}-${idx}`} flex="auto" xs={24} sm={12}>
                        <PlanCard plan={plan} bgColor={idx%2 === 0 ? "light" : "dark"} />
                    </Col>
                    ))}
                </Row>
                ): (<p>{t('Plan.no_plans')}</p>)}
            </PageViewSection>
        </PageView>
    );
}
